/**
 * @generated SignedSource<<4fbc4fdd39d311a887ec28ee05553708>>
 * @relayHash 10fe92827ef47a787a771b616dc7f528
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 86752f8a696c7f669a0ea4dbb46eac681bc489162308f5db3e43b2072edbf9fb

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type PTGraphQLPageStatus = "CURRENT" | "DRAFT" | "HISTORICAL" | "TRASHED" | "%future added value";
export type SitePermissionType = "ANONYMOUS" | "APP" | "EXTERNAL" | "INTERNAL" | "JSD" | "%future added value";
export type SpaceSidebarLinkType = "EXTERNAL_LINK" | "FORGE" | "PINNED_ATTACHMENT" | "PINNED_BLOG_POST" | "PINNED_PAGE" | "PINNED_SPACE" | "PINNED_USER_INFO" | "WEB_ITEM" | "%future added value";
export type SpaceNavigationQuery$variables = {
  cloudId: string;
  contentId?: string | null;
  includeHomepageTreeVariant?: boolean | null;
  includePageTree?: boolean | null;
  includePersistentInviteLicense?: boolean | null;
  includeSpaceCurationCount?: boolean | null;
  isLicensed: boolean;
  isSuperAdmin?: boolean | null;
  paginationLimit?: number | null;
  ptStatuses?: ReadonlyArray<PTGraphQLPageStatus | null> | null;
  spaceKey: string;
};
export type SpaceNavigationQuery$data = {
  readonly currentPage?: {
    readonly children: {
      readonly nodes: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly followingSiblings: {
      readonly nodes: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly nearestAncestors: {
      readonly nodes: ReadonlyArray<{
        readonly followingSiblings: {
          readonly nodes: ReadonlyArray<{
            readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
          } | null> | null;
          readonly pageInfo: {
            readonly hasNextPage: boolean;
          } | null;
        } | null;
        readonly previousSiblings: {
          readonly nodes: ReadonlyArray<{
            readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
          } | null> | null;
          readonly pageInfo: {
            readonly hasNextPage: boolean;
          } | null;
        } | null;
        readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
      } | null> | null;
      readonly pageInfo: {
        readonly endCursor: string | null;
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly previousSiblings: {
      readonly nodes: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
  } | null;
  readonly homepageRootPageTree?: {
    readonly followingSiblings: {
      readonly nodes: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
  } | null;
  readonly license?: {
    readonly " $fragmentSpreads": FragmentRefs<"PersistentInviteEligibleQuery_license">;
  } | null;
  readonly rootPageTree?: {
    readonly followingSiblings: {
      readonly nodes: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
      } | null> | null;
      readonly pageInfo: {
        readonly hasNextPage: boolean;
      } | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
  } | null;
  readonly space: {
    readonly containsExternalCollaborators: boolean;
    readonly currentUser?: {
      readonly isAdmin: boolean;
      readonly isFavourited: boolean;
      readonly isWatched: boolean;
    };
    readonly didContainUserContent: boolean;
    readonly history: {
      readonly createdDate: string | null;
    } | null;
    readonly homepage: {
      readonly id: string | null;
    } | null;
    readonly homepageId: string | null;
    readonly icon: {
      readonly path: string;
    } | null;
    readonly id: string | null;
    readonly key: string | null;
    readonly name: string | null;
    readonly operations: ReadonlyArray<{
      readonly operation: string | null;
      readonly targetType: string | null;
    } | null> | null;
    readonly pageTree?: {
      readonly children: {
        readonly nodes: ReadonlyArray<{
          readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
        } | null> | null;
        readonly pageInfo: {
          readonly hasNextPage: boolean;
        } | null;
      } | null;
      readonly followingSiblings: {
        readonly nodes: ReadonlyArray<{
          readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
        } | null> | null;
        readonly pageInfo: {
          readonly hasNextPage: boolean;
        } | null;
      } | null;
      readonly nearestAncestors: {
        readonly nodes: ReadonlyArray<{
          readonly followingSiblings: {
            readonly nodes: ReadonlyArray<{
              readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
            } | null> | null;
            readonly pageInfo: {
              readonly hasNextPage: boolean;
            } | null;
          } | null;
          readonly previousSiblings: {
            readonly nodes: ReadonlyArray<{
              readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
            } | null> | null;
            readonly pageInfo: {
              readonly hasNextPage: boolean;
            } | null;
          } | null;
          readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
        } | null> | null;
        readonly pageInfo: {
          readonly endCursor: string | null;
          readonly hasNextPage: boolean;
        } | null;
      } | null;
      readonly previousSiblings: {
        readonly nodes: ReadonlyArray<{
          readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
        } | null> | null;
        readonly pageInfo: {
          readonly hasNextPage: boolean;
        } | null;
      } | null;
      readonly " $fragmentSpreads": FragmentRefs<"PageTreeQuery_ptpage">;
    } | null;
    readonly status: string | null;
    readonly type: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"ExternalCollaboratorsSpaceInformationMessage_space" | "PersistentInviteEligibleQuery_space" | "SpaceHeader_space" | "SpaceOperationsFragment" | "useIsUserViewingSpaceAsAnon_space">;
  } | null;
  readonly spaceCurationSuggestionCount?: {
    readonly " $fragmentSpreads": FragmentRefs<"useFetchSuggestionCount_query">;
  } | null;
  readonly spaceSidebarLinks: {
    readonly main: ReadonlyArray<{
      readonly canHide: boolean | null;
      readonly hidden: boolean;
      readonly icon: {
        readonly height: number | null;
        readonly isDefault: boolean | null;
        readonly path: string;
        readonly width: number | null;
      } | null;
      readonly iconClass: string | null;
      readonly id: string;
      readonly linkIdentifier: string | null;
      readonly position: number;
      readonly styleClass: string | null;
      readonly title: string | null;
      readonly tooltip: string | null;
      readonly type: SpaceSidebarLinkType;
      readonly url: string | null;
      readonly webItemCompleteKey: string | null;
      readonly webItemKey: string | null;
    } | null> | null;
    readonly quick: ReadonlyArray<{
      readonly id: string;
      readonly position: number;
      readonly styleClass: string | null;
      readonly title: string | null;
      readonly url: string | null;
    } | null> | null;
  } | null;
  readonly user: {
    readonly confluence: {
      readonly permissionType: SitePermissionType | null;
    } | null;
    readonly id: string | null;
  } | null;
};
export type SpaceNavigationQuery = {
  response: SpaceNavigationQuery$data;
  variables: SpaceNavigationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v2 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeHomepageTreeVariant"
},
v3 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includePageTree"
},
v4 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includePersistentInviteLicense"
},
v5 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "includeSpaceCurationCount"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isLicensed"
},
v7 = {
  "defaultValue": false,
  "kind": "LocalArgument",
  "name": "isSuperAdmin"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "paginationLimit"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ptStatuses"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "spaceKey"
},
v11 = {
  "kind": "ScalarField",
  "name": "id"
},
v12 = {
  "alias": "user",
  "args": [
    {
      "kind": "Literal",
      "name": "current",
      "value": true
    }
  ],
  "concreteType": "AtlassianUser",
  "kind": "LinkedField",
  "name": "confluence_atlassianUser",
  "plural": false,
  "selections": [
    (v11/*: any*/),
    {
      "concreteType": "ConfluenceUser",
      "kind": "LinkedField",
      "name": "confluence",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "permissionType"
        }
      ]
    }
  ],
  "storageKey": "confluence_atlassianUser(current:true)"
},
v13 = {
  "kind": "Variable",
  "name": "spaceKey",
  "variableName": "spaceKey"
},
v14 = {
  "kind": "ScalarField",
  "name": "position"
},
v15 = {
  "kind": "ScalarField",
  "name": "title"
},
v16 = {
  "kind": "ScalarField",
  "name": "url"
},
v17 = {
  "kind": "ScalarField",
  "name": "styleClass"
},
v18 = {
  "kind": "ScalarField",
  "name": "path"
},
v19 = {
  "kind": "ScalarField",
  "name": "type"
},
v20 = {
  "args": [
    (v13/*: any*/)
  ],
  "concreteType": "SpaceSidebarLinks",
  "kind": "LinkedField",
  "name": "spaceSidebarLinks",
  "plural": false,
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "includeHidden",
          "value": true
        }
      ],
      "concreteType": "SpaceSidebarLink",
      "kind": "LinkedField",
      "name": "main",
      "plural": true,
      "selections": [
        (v11/*: any*/),
        {
          "kind": "ScalarField",
          "name": "webItemCompleteKey"
        },
        (v14/*: any*/),
        {
          "kind": "ScalarField",
          "name": "hidden"
        },
        {
          "kind": "ScalarField",
          "name": "webItemKey"
        },
        (v15/*: any*/),
        (v16/*: any*/),
        (v17/*: any*/),
        {
          "concreteType": "Icon",
          "kind": "LinkedField",
          "name": "icon",
          "plural": false,
          "selections": [
            (v18/*: any*/),
            {
              "kind": "ScalarField",
              "name": "width"
            },
            {
              "kind": "ScalarField",
              "name": "height"
            },
            {
              "kind": "ScalarField",
              "name": "isDefault"
            }
          ]
        },
        {
          "kind": "ScalarField",
          "name": "iconClass"
        },
        {
          "kind": "ScalarField",
          "name": "canHide"
        },
        {
          "kind": "ScalarField",
          "name": "tooltip"
        },
        {
          "kind": "ScalarField",
          "name": "linkIdentifier"
        },
        (v19/*: any*/)
      ],
      "storageKey": "main(includeHidden:true)"
    },
    {
      "concreteType": "SpaceSidebarLink",
      "kind": "LinkedField",
      "name": "quick",
      "plural": true,
      "selections": [
        (v11/*: any*/),
        (v16/*: any*/),
        (v14/*: any*/),
        (v15/*: any*/),
        (v17/*: any*/)
      ]
    }
  ]
},
v21 = [
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "spaceKey"
  }
],
v22 = {
  "kind": "ScalarField",
  "name": "key"
},
v23 = {
  "concreteType": "Content",
  "kind": "LinkedField",
  "name": "homepage",
  "plural": false,
  "selections": [
    (v11/*: any*/)
  ]
},
v24 = {
  "concreteType": "OperationCheckResult",
  "kind": "LinkedField",
  "name": "operations",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "operation"
    },
    {
      "kind": "ScalarField",
      "name": "targetType"
    }
  ]
},
v25 = {
  "kind": "ScalarField",
  "name": "didContainUserContent"
},
v26 = {
  "kind": "ScalarField",
  "name": "name"
},
v27 = {
  "kind": "ScalarField",
  "name": "status"
},
v28 = {
  "concreteType": "Icon",
  "kind": "LinkedField",
  "name": "icon",
  "plural": false,
  "selections": [
    (v18/*: any*/)
  ]
},
v29 = {
  "kind": "ScalarField",
  "name": "homepageId"
},
v30 = {
  "kind": "ScalarField",
  "name": "isAdmin"
},
v31 = {
  "kind": "ScalarField",
  "name": "isFavourited"
},
v32 = {
  "kind": "ScalarField",
  "name": "isWatched"
},
v33 = {
  "kind": "ScalarField",
  "name": "containsExternalCollaborators"
},
v34 = {
  "concreteType": "SpaceHistory",
  "kind": "LinkedField",
  "name": "history",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "createdDate"
    }
  ]
},
v35 = {
  "kind": "Literal",
  "name": "enablePaging",
  "value": true
},
v36 = {
  "kind": "Variable",
  "name": "pageTree",
  "variableName": "paginationLimit"
},
v37 = {
  "kind": "Variable",
  "name": "status",
  "variableName": "ptStatuses"
},
v38 = [
  (v35/*: any*/),
  (v36/*: any*/),
  (v37/*: any*/)
],
v39 = {
  "kind": "FragmentSpread",
  "name": "PageTreeQuery_ptpage"
},
v40 = {
  "kind": "ScalarField",
  "name": "hasNextPage"
},
v41 = {
  "concreteType": "PTPageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v40/*: any*/),
    {
      "kind": "ScalarField",
      "name": "endCursor"
    }
  ]
},
v42 = {
  "concreteType": "PTPageInfo",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    (v40/*: any*/)
  ]
},
v43 = [
  {
    "concreteType": "PTPage",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v39/*: any*/)
    ]
  },
  (v42/*: any*/)
],
v44 = {
  "concreteType": "PTPaginatedPageList",
  "kind": "LinkedField",
  "name": "previousSiblings",
  "plural": false,
  "selections": (v43/*: any*/)
},
v45 = {
  "concreteType": "PTPaginatedPageList",
  "kind": "LinkedField",
  "name": "followingSiblings",
  "plural": false,
  "selections": (v43/*: any*/)
},
v46 = [
  (v39/*: any*/),
  {
    "concreteType": "PTPaginatedPageList",
    "kind": "LinkedField",
    "name": "nearestAncestors",
    "plural": false,
    "selections": [
      (v41/*: any*/),
      {
        "concreteType": "PTPage",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v39/*: any*/),
          (v44/*: any*/),
          (v45/*: any*/)
        ]
      }
    ]
  },
  (v44/*: any*/),
  (v45/*: any*/),
  {
    "concreteType": "PTPaginatedPageList",
    "kind": "LinkedField",
    "name": "children",
    "plural": false,
    "selections": (v43/*: any*/)
  }
],
v47 = [
  (v35/*: any*/),
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "contentId"
  },
  (v36/*: any*/),
  (v13/*: any*/),
  (v37/*: any*/)
],
v48 = [
  (v35/*: any*/),
  (v36/*: any*/),
  (v13/*: any*/),
  (v37/*: any*/)
],
v49 = [
  (v39/*: any*/),
  (v45/*: any*/)
],
v50 = [
  (v13/*: any*/),
  (v37/*: any*/)
],
v51 = {
  "kind": "ScalarField",
  "name": "value"
},
v52 = {
  "args": [
    {
      "kind": "Literal",
      "name": "format",
      "value": "MILLIS"
    }
  ],
  "concreteType": "ConfluenceDate",
  "kind": "LinkedField",
  "name": "createdDate",
  "plural": false,
  "selections": [
    (v51/*: any*/)
  ],
  "storageKey": "createdDate(format:\"MILLIS\")"
},
v53 = {
  "kind": "ScalarField",
  "name": "hasChildren"
},
v54 = {
  "kind": "ScalarField",
  "name": "blank"
},
v55 = {
  "condition": "isSuperAdmin",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "hasRestrictions"
    },
    {
      "kind": "ScalarField",
      "name": "hasInheritedRestrictions"
    }
  ]
},
v56 = {
  "kind": "ScalarField",
  "name": "subType"
},
v57 = {
  "concreteType": "Map_LinkType_String",
  "kind": "LinkedField",
  "name": "links",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "webui"
    }
  ]
},
v58 = {
  "args": [
    {
      "kind": "Literal",
      "name": "keys",
      "value": [
        "emoji-title-published",
        "emoji-title-draft",
        "editor"
      ]
    }
  ],
  "concreteType": "PaginatedJsonContentPropertyList",
  "kind": "LinkedField",
  "name": "properties",
  "plural": false,
  "selections": [
    {
      "concreteType": "JsonContentProperty",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        (v11/*: any*/),
        (v22/*: any*/),
        (v51/*: any*/),
        {
          "concreteType": "Version",
          "kind": "LinkedField",
          "name": "version",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "number"
            }
          ]
        }
      ]
    }
  ],
  "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
},
v59 = [
  {
    "concreteType": "PTPage",
    "kind": "LinkedField",
    "name": "nodes",
    "plural": true,
    "selections": [
      (v11/*: any*/),
      (v15/*: any*/),
      (v27/*: any*/),
      (v52/*: any*/),
      (v53/*: any*/),
      (v54/*: any*/),
      (v55/*: any*/),
      (v19/*: any*/),
      (v56/*: any*/),
      (v57/*: any*/),
      (v58/*: any*/)
    ]
  },
  (v42/*: any*/)
],
v60 = {
  "concreteType": "PTPaginatedPageList",
  "kind": "LinkedField",
  "name": "previousSiblings",
  "plural": false,
  "selections": (v59/*: any*/)
},
v61 = {
  "concreteType": "PTPaginatedPageList",
  "kind": "LinkedField",
  "name": "followingSiblings",
  "plural": false,
  "selections": (v59/*: any*/)
},
v62 = [
  (v11/*: any*/),
  (v15/*: any*/),
  (v27/*: any*/),
  (v52/*: any*/),
  (v53/*: any*/),
  (v54/*: any*/),
  (v55/*: any*/),
  (v19/*: any*/),
  (v56/*: any*/),
  (v57/*: any*/),
  (v58/*: any*/),
  {
    "concreteType": "PTPaginatedPageList",
    "kind": "LinkedField",
    "name": "nearestAncestors",
    "plural": false,
    "selections": [
      (v41/*: any*/),
      {
        "concreteType": "PTPage",
        "kind": "LinkedField",
        "name": "nodes",
        "plural": true,
        "selections": [
          (v11/*: any*/),
          (v15/*: any*/),
          (v27/*: any*/),
          (v52/*: any*/),
          (v53/*: any*/),
          (v54/*: any*/),
          (v55/*: any*/),
          (v19/*: any*/),
          (v56/*: any*/),
          (v57/*: any*/),
          (v58/*: any*/),
          (v60/*: any*/),
          (v61/*: any*/)
        ]
      }
    ]
  },
  (v60/*: any*/),
  (v61/*: any*/),
  {
    "concreteType": "PTPaginatedPageList",
    "kind": "LinkedField",
    "name": "children",
    "plural": false,
    "selections": (v59/*: any*/)
  }
],
v63 = [
  (v11/*: any*/),
  (v15/*: any*/),
  (v27/*: any*/),
  (v52/*: any*/),
  (v53/*: any*/),
  (v54/*: any*/),
  (v55/*: any*/),
  (v19/*: any*/),
  (v56/*: any*/),
  (v57/*: any*/),
  (v58/*: any*/),
  (v61/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/)
    ],
    "kind": "Fragment",
    "name": "SpaceNavigationQuery",
    "selections": [
      (v12/*: any*/),
      {
        "condition": "includeSpaceCurationCount",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "fragment": {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "FragmentSpread",
                  "name": "useFetchSuggestionCount_query"
                }
              ],
              "type": "Query"
            },
            "kind": "AliasedInlineFragmentSpread",
            "name": "spaceCurationSuggestionCount"
          }
        ]
      },
      {
        "condition": "includePersistentInviteLicense",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "License",
            "kind": "LinkedField",
            "name": "license",
            "plural": false,
            "selections": [
              {
                "kind": "FragmentSpread",
                "name": "PersistentInviteEligibleQuery_license"
              }
            ]
          }
        ]
      },
      (v20/*: any*/),
      {
        "args": (v21/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "useIsUserViewingSpaceAsAnon_space"
          },
          {
            "kind": "FragmentSpread",
            "name": "PersistentInviteEligibleQuery_space"
          },
          {
            "kind": "FragmentSpread",
            "name": "ExternalCollaboratorsSpaceInformationMessage_space"
          },
          {
            "args": [
              {
                "kind": "Variable",
                "name": "isLicensed",
                "variableName": "isLicensed"
              }
            ],
            "kind": "FragmentSpread",
            "name": "SpaceHeader_space"
          },
          (v11/*: any*/),
          (v22/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          {
            "kind": "FragmentSpread",
            "name": "SpaceOperationsFragment"
          },
          (v25/*: any*/),
          (v26/*: any*/),
          (v19/*: any*/),
          (v27/*: any*/),
          (v28/*: any*/),
          (v29/*: any*/),
          {
            "condition": "isLicensed",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "SpaceUserMetadata",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  (v30/*: any*/),
                  (v31/*: any*/),
                  (v32/*: any*/)
                ]
              }
            ]
          },
          (v33/*: any*/),
          (v34/*: any*/),
          {
            "condition": "includeHomepageTreeVariant",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v38/*: any*/),
                "concreteType": "PTPage",
                "kind": "LinkedField",
                "name": "pageTree",
                "plural": false,
                "selections": (v46/*: any*/)
              }
            ]
          }
        ]
      },
      {
        "condition": "includePageTree",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "currentPage",
            "args": (v47/*: any*/),
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": (v46/*: any*/)
          },
          {
            "alias": "rootPageTree",
            "args": (v48/*: any*/),
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": (v49/*: any*/)
          }
        ]
      },
      {
        "condition": "includeHomepageTreeVariant",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "homepageRootPageTree",
            "args": (v50/*: any*/),
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": (v49/*: any*/)
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v10/*: any*/),
      (v6/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/),
      (v9/*: any*/),
      (v8/*: any*/),
      (v7/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/)
    ],
    "kind": "Operation",
    "name": "SpaceNavigationQuery",
    "selections": [
      (v12/*: any*/),
      (v20/*: any*/),
      {
        "args": (v21/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          (v11/*: any*/),
          {
            "concreteType": "SpaceUserMetadata",
            "kind": "LinkedField",
            "name": "currentUser",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "isAnonymouslyAuthorized"
              },
              (v30/*: any*/)
            ]
          },
          (v26/*: any*/),
          {
            "kind": "ScalarField",
            "name": "externalCollaboratorCount"
          },
          (v22/*: any*/),
          (v27/*: any*/),
          (v28/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          (v33/*: any*/),
          (v25/*: any*/),
          (v19/*: any*/),
          (v29/*: any*/),
          (v34/*: any*/),
          {
            "condition": "isLicensed",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "concreteType": "SpaceUserMetadata",
                "kind": "LinkedField",
                "name": "currentUser",
                "plural": false,
                "selections": [
                  (v31/*: any*/),
                  (v32/*: any*/)
                ]
              }
            ]
          },
          {
            "condition": "includeHomepageTreeVariant",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "args": (v38/*: any*/),
                "concreteType": "PTPage",
                "kind": "LinkedField",
                "name": "pageTree",
                "plural": false,
                "selections": (v62/*: any*/)
              }
            ]
          }
        ]
      },
      {
        "condition": "includeSpaceCurationCount",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "cloudId",
                "variableName": "cloudId"
              },
              (v13/*: any*/)
            ],
            "kind": "ScalarField",
            "name": "confluence_remoteObjectSuggestionCount"
          }
        ]
      },
      {
        "condition": "includePersistentInviteLicense",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "concreteType": "License",
            "kind": "LinkedField",
            "name": "license",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "licenseConsumingUserCount"
              },
              {
                "kind": "ScalarField",
                "name": "trialEndDate"
              }
            ]
          }
        ]
      },
      {
        "condition": "includePageTree",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "currentPage",
            "args": (v47/*: any*/),
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": (v62/*: any*/)
          },
          {
            "alias": "rootPageTree",
            "args": (v48/*: any*/),
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": (v63/*: any*/)
          }
        ]
      },
      {
        "condition": "includeHomepageTreeVariant",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "alias": "homepageRootPageTree",
            "args": (v50/*: any*/),
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": (v63/*: any*/)
          }
        ]
      }
    ]
  },
  "params": {
    "cacheID": "10fe92827ef47a787a771b616dc7f528",
    "id": "86752f8a696c7f669a0ea4dbb46eac681bc489162308f5db3e43b2072edbf9fb",
    "metadata": {},
    "name": "SpaceNavigationQuery",
    "operationKind": "query",
    "text": "query SpaceNavigationQuery($cloudId:ID!,$spaceKey:String!,$isLicensed:Boolean!,$includePersistentInviteLicense:Boolean=false,$includeSpaceCurationCount:Boolean=false,$contentId:ID,$ptStatuses:[PTGraphQLPageStatus],$paginationLimit:Int,$isSuperAdmin:Boolean=false,$includePageTree:Boolean=false,$includeHomepageTreeVariant:Boolean=false){user:confluence_atlassianUser(current:true){id,confluence{permissionType}},...useFetchSuggestionCount_query@include(if:$includeSpaceCurationCount),license@include(if:$includePersistentInviteLicense){...PersistentInviteEligibleQuery_license},spaceSidebarLinks(spaceKey:$spaceKey){main(includeHidden:true){id,webItemCompleteKey,position,hidden,webItemKey,title,url,styleClass,icon{path,width,height,isDefault},iconClass,canHide,tooltip,linkIdentifier,type},quick{id,url,position,title,styleClass}},space(key:$spaceKey){...useIsUserViewingSpaceAsAnon_space,...PersistentInviteEligibleQuery_space,...ExternalCollaboratorsSpaceInformationMessage_space,...SpaceHeader_space_3F1fcg,id,key,homepage{id},operations{operation,targetType},...SpaceOperationsFragment,didContainUserContent,name,type,status,icon{path},homepageId,currentUser@include(if:$isLicensed){isAdmin,isFavourited,isWatched},containsExternalCollaborators,history{createdDate},pageTree(pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true)@include(if:$includeHomepageTreeVariant){...PageTreeQuery_ptpage,nearestAncestors{pageInfo{hasNextPage,endCursor},nodes{...PageTreeQuery_ptpage,previousSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id}},previousSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},children{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id}},currentPage:ptpage(id:$contentId,spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true)@include(if:$includePageTree){...PageTreeQuery_ptpage,nearestAncestors{pageInfo{hasNextPage,endCursor},nodes{...PageTreeQuery_ptpage,previousSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id}},previousSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},children{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id}\n  rootPageTree:ptpage(spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true)@include(if:$includePageTree){...PageTreeQuery_ptpage,followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id},homepageRootPageTree:ptpage(spaceKey:$spaceKey,status:$ptStatuses)@include(if:$includeHomepageTreeVariant){...PageTreeQuery_ptpage,followingSiblings{nodes{...PageTreeQuery_ptpage,id},pageInfo{hasNextPage}},id}}fragment ExternalCollaboratorsSpaceInformationMessage_space on Space{id,name,externalCollaboratorCount,currentUser{isAdmin}}fragment PageTreeQuery_ptpage on PTPage{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n  hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}}fragment PersistentInviteEligibleQuery_license on License{licenseConsumingUserCount,trialEndDate}fragment PersistentInviteEligibleQuery_space on Space{id,currentUser{isAnonymouslyAuthorized}}fragment SpaceHeader_space_3F1fcg on Space{id,key,name,status,icon{path},homepage{id},currentUser@include(if:$isLicensed){isAdmin,isFavourited,isWatched},operations{operation,targetType},containsExternalCollaborators}fragment SpaceOperationsFragment on Space{id,operations{operation,targetType}}fragment useFetchSuggestionCount_query on Query{confluence_remoteObjectSuggestionCount(cloudId:$cloudId,spaceKey:$spaceKey)}fragment useIsUserViewingSpaceAsAnon_space on Space{id,currentUser{isAnonymouslyAuthorized}}"
  }
};
})();

(node as any).hash = "cb328946c4855d5d5935cc72c0bb6f1c";

export default node;
